import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    carousel: 'gap-2 snap-always'
  },
  controlslist: 'nodownload'
} satisfies VfConfig['mediaGallery']
